import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-hot-toast";
import axios from "../../API/axios";
import { people } from "../../config/imagesLink";
import AddJob from "../ManageJob/AddJob";
import DraftJob from "../ManageJob/DraftJob";
import Select from "react-select";
import ModalForGuest from "../ModalForGuest";
import SuccessToast from "../SuccessToast";
import ErrorToast from "../ErrorToast";
import WarningToast from "../WarningToast";
import { customStyles } from "../../selectStyles";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import ImageSharpIcon from "@mui/icons-material/ImageSharp";
import VideoCameraBackIcon from '@mui/icons-material/VideoCameraBack';
import WorkOutlineSharpIcon from "@mui/icons-material/WorkOutlineSharp";
import ReactQuill from "react-quill";
import { FaRegPenToSquare } from "react-icons/fa6";
import "react-quill/dist/quill.snow.css"; // Import the styles
import PublicSharpIcon from "@mui/icons-material/PublicSharp";
import GroupSharpIcon from "@mui/icons-material/GroupSharp";
import LockSharpIcon from "@mui/icons-material/LockSharp";
import TuneSharpIcon from "@mui/icons-material/TuneSharp";
import CompanyWarning from "../CompanyWarning";
import AddArticle from "../Articles/AddArticle";
import LoadingToasterBar from "../LoadingToasterBar";

// import { Tooltip } from "react-bootstrap";
import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from "react-i18next";

const AddPost = ({
  // restrictedViewerToken,
  AllPostList,
  postList,
  PostOriginType,
  companyDetails,
  setPostList,
  postOriginId,
  setIsVideoProcessing,
  setProgress,
  setUserStat,
  setCompanyStats,
  CompanyStatsCount,
  setIsLiked,
  isLiked,
  currentSortType
  // restrictedViewerToken
}) => {
  const { t } = useTranslation();

  const Privacy = [
    // { value: "Public", label: "Public" , icon: <PublicSharpIcon /> },
    // { value: "Friends", label: "Friends" , icon: <GroupSharpIcon /> },
    // { value: "OnlyMe", label: "OnlyMe", icon: <LockSharpIcon /> },
    // { value: "Custom", label: "Custom" , icon: <TuneSharpIcon /> },
    { value: "Public", label: t("Newsfeed.Public"), icon: <PublicSharpIcon /> },
    { value: "Friends", label: t("Newsfeed.Friends"), icon: <GroupSharpIcon /> },
    { value: "OnlyMe", label: t("Newsfeed.OnlyMe"), icon: <LockSharpIcon /> },
    { value: "Custom", label: t("Newsfeed.Custom"), icon: <TuneSharpIcon /> },
  ];
  // const editorRef = useRef(null);
  const guestModeData = localStorage.getItem("guestMode");
  const ownCompanyList = localStorage.getItem("ownCompanyList");
  // console.log("ownCompanyList", ownCompanyList);
  const restrictedViewerToken = localStorage.getItem("restrictedViewerToken");

  const profilPic = localStorage.getItem("profilPic");
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const [showJobModal, setShowJobModal] = useState(false);
  const [showArticleModal, setShowArticleModal] = useState(false);

  //DS
  const [selectedIndex, setSelectedIndex] = useState(0);
  const suggestionListRef = useRef(null);
  const itemRefs = useRef([]);

  const openJobModal = () => {
    setShowJobModal(true);
  };
  const closeJobModal = () => {
    setShowJobModal(false);
  };
  const openArticleModal = () => {
    // console.log("Opening Article Modal...");
    setShowArticleModal(true);
  };

  const closeArticleModal = () => {
    setShowArticleModal(false);
  };

  const [showJobDraftModal, setShowJobDraftModal] = useState(false);
  const openJobDraftModal = () => {
    setShowJobDraftModal(true);
  };

  const closeJobDraftModal = () => {
    setShowJobDraftModal(false);
    // console.log("Closing Job Draft Modal...", showJobDraftModal);
  };

  const [showwarningmodal, setShowwarningmodal] = useState(false);
  const openWarningModal = () => {
    setShowwarningmodal(true);
  };
  const closewarningmodal = () => {
    setShowwarningmodal(false);
  };

  const [showModal, setShowModal] = useState(false);
  const [showModalData, setShowModalData] = useState(false);

  const openModal = () => {
    {
      guestModeData === "true" ? setShowModalData(true) : setShow(true);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setShow(false);
    setPostDynamicValues([]);
    setPostInputValue("");
    setPostContent("");
    setSuggestions([]);
    setShowSuggestions(false);
  };
  const closeModalData = () => {
    setShowModalData(false);
  };
  const [showDraftModal, setShowDraftModal] = useState(false);

  const openDraftModal = () => {
    setShowDraftModal(true);
  };

  const closeDraftModal = () => {
    setShowDraftModal(false);
  };
  const textareaRef = useRef(null);
  const [postData, setPostData] = useState("");

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.focus();
    }
  }, []);
  const sessionId = localStorage.getItem("sessionId");
  const userUid = localStorage.getItem("userUid");

  //************************ Add Post   ************************//
  const [postID, setPostID] = useState("");
  const [display, setDisplay] = useState(false);

  const [query, setQuery] = useState(""); // Store the full query
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [cursorPosition, setCursorPosition] = useState(0);
  const [postContent, setPostContent] = useState("");
  const [postInputValue, setPostInputValue] = useState("");
  const [postDynamicValues, setPostDynamicValues] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [mentionType, setMentionType] = useState("");
  const [SearchText, setSearchText] = useState("")

  const [VideoValue, setVideoValue] = useState(null)
  const [VideoId, setVideoId] = useState(null)
  const editorRef = useRef(null);

  const fileInputRef = useRef(null);
  const language = localStorage.getItem("Lang");

  const [show, setShow] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [imageNames, setImageNames] = useState("");
  const [imageNamesFile, setImageNamesFile] = useState("");
  const inputFileRef = useRef(null);

  const [images, setImages] = useState([]);
  const [video, setVideo] = useState([]);

  const [selectedFiles, setSelectedFiles] = useState([]);

  const handleShow = () => setShow(true);
  const [showSecondModal, setShowSecondModal] = useState(false);

  const [privacyType, setPrivacyType] = useState(t("Select privacy"));

  const [isloading, setIsloading] = useState(false);

  const [isVideoSelected, setIsVideoSelected] = useState(false)
  //************************ Add Post   ************************//

  const imageSelect = (event) => {
    // console.log("image selected", event);
    const selectedFiles = event.target.files;
    const newImages = [];

    for (let i = 0; i < selectedFiles.length; i++) {
      const imageName = selectedFiles[i].name;
      if (!checkDuplicate(imageName)) {
        const imageUrl = URL.createObjectURL(selectedFiles[i]);
        newImages.push({
          name: imageName,
          url: imageUrl,
          file: selectedFiles[i],
        });
      } else {
        alert(`${imageName} is already added to the list`);
      }
    }
    setIsVideoSelected(false)
    setImages((prevImages) => {
      const updatedImages = [...prevImages, ...newImages];
      // console.log("Updated images list:", updatedImages);
      return updatedImages;
    });
    // console.log("selected images", newImages);

    event.target.value = null; // Reset file input
    // handleImageChange(newImages)
  };
  const videoSelect = (event) => {
    // console.log("Video selected", event);
    const selectedFiles = event.target.files;
    const newVideo = [];

    for (let i = 0; i < selectedFiles.length; i++) {
      const videoName = selectedFiles[i].name;
      if (!checkDuplicateVideo(videoName)) {
        const videoURL = URL.createObjectURL(selectedFiles[i]);
        newVideo.push({
          name: videoName,
          url: videoURL,
          file: selectedFiles[i],
        });
      } else {
        alert(`${videoName} is already added to the list`);
      }
    }

    setVideo((prevVideo) => {
      const updatedImages = [...prevVideo, ...newVideo];
      // console.log("Updated Video list:", updatedImages);
      return updatedImages;
    });
    setIsVideoSelected(true)
    // console.log("selected Video", newVideo);

    event.target.value = null; // Reset file input
    // handleImageChange(newVideo)
  };

  const checkDuplicate = (name) => {
    return images.some((image) => image.name === name);
  };
  const checkDuplicateVideo = (name) => {
    return video.some((video) => video.name === name);
  };

  const renderImages = () => {
    return images.map((image, index) => (
      <div
        key={index}
        className="image_container d-flex justify-content-center position-relative"
      >
        <img src={image.url} alt={image.name} />
        <span className="position-absolute" onClick={() => deleteImage(index)}>
          &times;
        </span>
      </div>
    ));
  };
  const renderVideo = () => {
    return video.map((video, index) => (
      <div
        key={index}
        className="image_container d-flex justify-content-center position-relative"
      >
        {/* <img src={video.url} alt={video.name} /> */}
        <video width="100%" height="100" controls>
          <source src={video.url} type="video/mp4" />
        </video>
        <span className="position-absolute" onClick={() => deleteVideo(index)}>
          &times;
        </span>
      </div>
    ));
  };

  const handleImageChange = (images) => {
    // console.log("selected images", images);
    if (postID === "") {
      SavePostAsDraft(images);
    } else {
      UpdatePostAsDraft(images);
    }
  };

  const handleRemoveImage = (index) => {
    UpdatePostAsDraft();
    setSelectedImages((prevImages) => prevImages.filter((_, i) => i !== index));
    setImageNames((prevNames) => {
      const namesArray = prevNames.split(", ");
      namesArray.splice(index, 1);
      return namesArray.join(", ");
    });
  };

  const handleClose = () => {
    setShow(false);

  };

  const handlePost = () => {
    setShow(false);
    setShowModal(false);
    setShowSecondModal(true);
  };


  const determinePostCategory = (postContent, imageNameArray) => {
    // console.log("postContent", postContent, imageNameArray);

    const containsVideo = (names) => {
      const videoExtensions = [
        ".mp4",
        ".webm",
        ".avi",
        ".mov",
        ".mkv",
        ".flv",
        ".wmv",
      ];
      return names.some((name) =>
        videoExtensions.includes(
          name?.slice(name.lastIndexOf(".")).toLowerCase()
        )
      );
    };

    const hasPostContent = postContent?.trim() !== "";
    const hasMedia = imageNameArray?.length > 0;
    const hasImages = hasMedia && !containsVideo(imageNameArray);
    const hasVideos = hasMedia && containsVideo(imageNameArray);

    if (hasPostContent && hasImages && !hasVideos) {
      return "TextWithImage";
    } else if (hasPostContent && hasVideos && !hasImages) {
      return "TextWithVideo";
    } else if (hasImages && !hasPostContent && !hasVideos) {
      return "Image";
    } else if (hasVideos && !hasPostContent && !hasImages) {
      return "Video";
    } else if (hasPostContent && !hasImages && !hasVideos) {
      return "Text";
    } else {
      return "UseStory"; // fallback if something weird happens
    }
  };

  const handleSubmit = async () => {
    let postCreatedSuccessfully = false;

    // console.log("posted", images.length <= 0);
    try {
      setDisplay(true);
      if (privacyType === "Select privacy" || privacyType === "") {
        setIsloading(false);
        setWarningToastMessage(t("Newsfeed.Please select privacy before posting"));
        setShowWarningToast(true);
        return
      }
      if (postContent === "" && images.length <= 0) {
        setErrorToastMessage("Please add content or image");
        setShowErrorToast(true);
        return; // ✅ ADD THIS
      } else {
        setIsloading(true);
        const formData = new FormData();
        formData.append("DeviceType", "Web");
        formData.append("sessionId", sessionId);
        formData.append("PrivacyType", privacyType || "Public");
        formData.append("PostOriginType", PostOriginType);
        const imageNameArray = images.map((image) => image.name);
        const postCategory = determinePostCategory(postInputValue, imageNameArray);
        formData.append("PostCategory", postCategory);
        formData.append("PostContent", postInputValue ? postInputValue : postContent);
        formData.append("DynamicValues", JSON.stringify(postDynamicValues));
        images.forEach((file, index) => {
          formData.append(`FilesToUpload`, file.file);
        });
        formData.append("PostOriginID", postOriginId);

        const res = await axios.post(`/Posts/CreatePost?LangKey=${language}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }); 

        if (res?.status === 200) {
          postCreatedSuccessfully = true;
          setToastMessage(res?.data.message);
          setShowToast(true);
          handleClose();
          setShowSecondModal(false);
          setPostDynamicValues([]);
          setPostInputValue("");
          setPostContent("");
          setImages([]);
          setVideo([]);
          setPostID("");
          setIsLiked(null);
          setIsloading(false);
          setPreviewData(null);

          const newPostId = res?.data?.responseData?.id;
          console.log("postdataa", newPostId);

          // const postDetailsResponse = await axios.get(
          //   `/Posts/GetPostInfo?DeviceType=Web&PostId=${newPostId}&RestrictedViewerToken=${restrictedViewerToken}&langKey=${language}`
          // );
          // const newPost = postDetailsResponse?.data?.responseData?.postInfo; 
          // if (postList?.length === 0) { 
          //   await AllPostList(1);
          // } else { 
          //   setPostList((prev) => [newPost, ...(prev || [])]);
          // } 


          try {
            if (newPostId) {
              const postDetailsResponse = await axios.get(
                `/Posts/GetPostInfo?DeviceType=Web&PostId=${newPostId}&RestrictedViewerToken=${restrictedViewerToken}&langKey=${language}`
              );

              const newPost = postDetailsResponse?.data?.responseData?.postInfo;

              if (postList?.length === 0) {
                await AllPostList(1);
              } else {
                setPostList((prev) => [newPost, ...(prev || [])]);
              }
            }
          } catch (err) {
            console.warn("Post created but failed to fetch post info", err);
            //  DO NOT show error toast here
          }

          if (PostOriginType === "Company") {
            setCompanyStats((prev) => ({
              ...prev,
              totalPosts: (prev?.totalPosts || 0) + 1
            }));
          } else {
            setUserStat((prev) => ({
              ...prev,
              postsCount: (prev?.postsCount || 0) + 1
            }));
          }
        }

      }
    } catch (error) {
      // console.log("newPostId", error);
      if (!postCreatedSuccessfully) {
        if (error?.response && error?.response?.status === 404) {
          setWarningToastMessage(error?.response?.data?.message);
          setShowWarningToast(true);
          setIsloading(false);
        } else {
          setErrorToastMessage(error?.response?.data?.message);
          setShowErrorToast(true);
          setIsloading(false);
        }
      }
      setIsloading(false);
    }
  };

  // const [progress, setProgress] = useState("");
  const [apiCount, setApiCount] = useState(0);
  const [reFresh, setRefresh] = useState(false);
  const [NewPostId, setnewPostId] = useState("");
  const [videoIds, setvideoId] = useState("");
  // const [isVideoProcessing, setIsVideoProcessing] = useState(false);


  const handleVideoPostApiCall = async () => {
    setIsloading(true);
    setDisplay(true);

    if (postContent === "" && video.length === 0) {
      setErrorToastMessage("Please add content or Video");
      setShowErrorToast(true);
      setIsloading(false);
      return;
    }
    if (privacyType === "Select privacy" || privacyType === "") {
      setIsloading(false);
      setWarningToastMessage(t("Newsfeed.Please select privacy before posting"));
      setShowWarningToast(true);
      return
    }
    try {

      // const normalizedValues = normalizeDynamicValues(postDynamicValues);
      // const formattedPostContent = updatePostInputValueWithDynamicValues(
      //   postInputValue || postContent,
      //   normalizedValues
      // );
      const formData = new FormData();
      formData.append("DeviceType", "Web");
      formData.append("sessionId", sessionId);
      formData.append("PrivacyType", privacyType || "Public");
      formData.append("PostOriginType", PostOriginType);
      formData.append("PostOriginId", postOriginId);
      formData.append(
        "PostCategory",
        postContent !== "" && video.length > 0 ? "TextWithVideo" : "Video"
      );
      formData.append("PostContent", postInputValue ? postInputValue : postContent);
      formData.append("DynamicValues", JSON.stringify(postDynamicValues));
      formData.append("PostContent", JSON.stringify(postDynamicValues));
      formData.append("langKey", language === "en" ? "" : language);

      // formData.append("PostContent", formattedPostContent);
      // formData.append("DynamicValues", JSON.stringify(normalizedValues));

      // video.forEach((fileObj) => {
      //   formData.append("FilesToUpload", fileObj?.file);
      // });
      if (video.length > 0) {
        formData.append("FileToUpload", video[0].file);
      }
      const res = await axios.post(`/Posts/VideoPost?LangKey=${language}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res?.status === 200) {
        handleClose();
        setImages([]);
        setVideo([]);
        setPostDynamicValues([]);
        setPostInputValue("");
        setPostContent("");
        setPostID("");
        setIsloading(false);
        setToastMessage(res?.data.message);
        setShowToast(true);
        setPreviewData(null);

      }
      const newPostId = res?.data?.responseData?.id;
      const newPostValue = res?.data?.responseData?.value;

      const payload = {
        deviceType: "Web",
        sessionId: sessionId,
        postId: newPostId,
        pstMid: Number(newPostValue),
        langKey: language === "en" ? "" : language,

      };

      const resData = await axios.post(`/Posts/ProcessVideoPostFile`, payload);
      const videoId = resData?.data?.responseData?.videoId;

      setnewPostId(newPostId);
      setvideoId(videoId);

      setIsVideoProcessing(true);

      let progressReached = false;
      let attempts = 0;
      while (!progressReached && attempts < 30) {
        const isProcessed = await checkVideoStatus(newPostId, videoId);
        if (isProcessed) {
          setIsVideoProcessing(false);
          progressReached = true;
          break;
        }
        attempts++;
        await new Promise((res) => setTimeout(res, 3000));
      }

      //  Once processing completes
      if (progressReached) {
        await new Promise((res) => setTimeout(res, 1000));
        const postDetailsResponse = await axios.get(
          `/Posts/GetPostInfo?DeviceType=Web&PostId=${newPostId}&RestrictedViewerToken=${restrictedViewerToken}&langKey=${language}`
        );
        const newPost = postDetailsResponse?.data?.responseData?.postInfo;

        await AllPostList(); // Refetch list
        setPostList((prev) => [newPost, ...prev]); // Add new post at top
      } else {
        setWarningToastMessage("Video processing timeout. Try again later.");
        setShowWarningToast(true);
      }

      // Reset
      setToastMessage(""); // remove processing message
      setPostContent("");
      setImages([]);
      setVideo([]);
      setPostID("");
      setShowSecondModal(false);
      setIsloading(false);
      setPostDynamicValues([]);
      setPostInputValue("");
    } catch (error) {
      console.error("Video post failed:", error);
      setIsloading(false);
      if (error.response) {
        const message = error.response.data.message;
        if (error.response.status === 404) {
          setWarningToastMessage(message);
          setShowWarningToast(true);
        } else if (error.response.status === 409) {
          setErrorToastMessage(error.response.data.message);
          setShowErrorToast(true);
        } else if (error.response.status === 413) {
          setErrorToastMessage("The video size exceeds the allowable limit.");
          // setErrorToastMessage(""+ t("Newsfeed.The video size exceeds the allowable limit."));
          setShowErrorToast(true);
        } else {
          setErrorToastMessage(error.response.data.message);
          setShowErrorToast(true);
        }
      }
    }
  };

  const checkVideoStatus = async (postId, videoId) => {
    try {
      const reqData = {
        deviceType: "Web",
        postId: postId,
        videoID: videoId,
        restrictedViewerToken: restrictedViewerToken,
        langKey: language === "en" ? "" : language,

      };

      const res = await axios.post(`Posts/GetVideoIndexInsight`, reqData);
      if (res?.data?.status === "Success") {
        setApiCount((prev) => prev + 1);
        const percentage = parseInt(res?.data?.responseData?.processingProgress.replace('%', ''), 10);
        setProgress(percentage);
        return percentage === 100;
      } else {
        return false;
      }
    } catch (e) {
      console.error(e);
      return false;
    }
  };

  const determinePostCategory1 = (postContent, imageNameArray) => {
    // console.log('postContent', postContent, imageNameArray);

    const containsVideo = (names) => {
      const videoExtensions = [
        ".mp4",
        ".webm",
        ".avi",
        ".mov",
        ".mkv",
        ".flv",
        ".wmv",
      ];
      return names.some((name) =>
        videoExtensions.includes(
          name?.slice(name.lastIndexOf(".")).toLowerCase()
        )
      );
    };

    const hasPostContent = postContent !== "";
    const hasImages =
      imageNameArray.length > 0 && !containsVideo(imageNameArray);
    const hasVideos =
      imageNameArray.length > 0 && containsVideo(imageNameArray);

    if (
      (hasPostContent && hasImages) ||
      (hasPostContent && hasVideos) ||
      (hasImages && hasVideos)
    ) {
      return "UserStory";
    } else if (hasPostContent) {
      return "Text";
    } else if (hasImages) {
      return "Image";
    } else if (hasVideos) {
      return "Video";
    } else {
      return "UserStory";
    }
  };

  const SavePostAsDraft = async (images) => {
    // console.log("selected images", images);
    try {
      const formData = new FormData();
      formData.append("DeviceType", "Web");
      formData.append("sessionId", sessionId);
      formData.append("PrivacyType", privacyType || "Public");
      formData.append("PostOriginType", PostOriginType);
      const imageNameArray = images.map((image) => image.name);
      const postCategory = determinePostCategory1(postContent, imageNameArray);
      formData.append("PostCategory", postCategory);
      formData.append("PostContent", postContent);
      formData.append("DynamicValues", JSON.stringify(postDynamicValues));
      images.forEach((file, index) => {
        formData.append("FilesToUpload", file.file);
        // formData.append("langKey", language === "en" ? "" : language);
      });
      formData.append("PostOriginID", postOriginId);
      const res = await axios.post(`/Posts/SavePostAsDraft?LangKey=${language}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setPostID(res?.data?.responseData?.postId);
      setToastMessage(res?.data?.message);
      setShowToast(true);
      // AllPostList(1, currentSortType);
    } catch (e) {
      console.log(e);
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  const UpdatePostAsDraft = async (images) => {
    try {
      const formData = new FormData();
      formData.append("DeviceType", "Web");
      formData.append("sessionId", sessionId);
      formData.append("PrivacyType", privacyType || "Public");
      formData.append("PostOriginType", PostOriginType);
      const imageNameArray = images.map((image) => image.name);
      const postCategory = determinePostCategory(postContent, imageNameArray);
      formData.append("PostCategory", postCategory);
      formData.append("PostContent", postContent);
      formData.append("DynamicValues", JSON.stringify(postDynamicValues));
      images.forEach((file, index) => {
        formData.append(`FilesToUpload`, file.file);
      });
      formData.append("PostOriginID", postOriginId);
      formData.append("PostId", postID);
      formData.append("langKey", language === "en" ? "" : language);

      const res = await axios.post(`/Posts/UpdatePostDraft?LangKey=${language}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setPostID(res.data.responseData.postId);
      setPostContent("");
      setToastMessage(res.data.message);
      setShowToast(true);
    } catch (e) {
      console.log(e);
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  const removeImage = (index) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  const removeVideo = (index) => {
    setVideo((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  const deleteImage = (index) => {
    const updatedImages = [...images];
    updatedImages.splice(index, 1);
    setImages(updatedImages);
  };

  const deleteVideo = (index) => {
    const updatedVideo = [...video];
    updatedVideo.splice(index, 1);
    setVideo(updatedVideo);
  };

  const handleFileChange = (e) => {
    setSelectedFiles([...e.target.files]);
  };

  useEffect(() => {
    if (show || showModal || showDraftModal) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.body.classList.add("modal-open"); // When a modal opens
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "";
      document.body.classList.remove("modal-open"); // When a modal closes
    }
  }, [show, showModal, showDraftModal]);

  const handlePaste = (e) => {
    const isCtrlV = e.ctrlKey && e.key === "v"; // Check if Ctrl+V was pressed

    if (isCtrlV) {
      e.preventDefault(); // Prevent the default paste action
      alert("Please use Ctrl + Shift + V to paste."); // Show alert
    }
  };

  useEffect(() => {
    if (showJobDraftModal) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.body.classList.add("modal-open"); // When a modal opens
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "";
      document.body.classList.remove("modal-open"); // When a modal closes
    }
  }, [showJobDraftModal]);

  const normalizeDynamicValues = (dVals = []) =>
    dVals.map((item) => ({
      dVno: item.dVno,
      displayName: item.display || item.displayName,
      type: item.type,
      entity: item.entity || item.entityID,
    }));

  const parsePostContent = (apiContent, dynamicValues) => {
    const placeholderMap = {};
    dynamicValues.forEach(({ dVno, displayName, type }) => {
      placeholderMap[dVno] =
        type === "UserMention"
          ? `@${displayName}`
          : type === "Hashtag"
            ? `#${displayName}`
            : displayName;
    });

    let parsed = apiContent;
    Object.keys(placeholderMap).forEach((key) => {
      parsed = parsed.replace(new RegExp(`\\{${key}\\}`, "g"), placeholderMap[key]);
    });

    return parsed?.replace(/<[^>]*>/g, "").trim();
  };

  const [previewData, setPreviewData] = useState(null);
  const [detectedUrl, setDetectedUrl] = useState(null);

  const generatePreview = async (url) => {
    try {
      const endpoint = "https://api.linkpreview.net";
      const apiKey = "ca99516e124a75141e5cea8eb3148b6b";

      const response = await axios.get(
        `${endpoint}?key=${apiKey}&q=${encodeURIComponent(url)}`
      );

      setPreviewData(response.data);
      setDetectedUrl(url);
    } catch (error) {
      console.log("Preview not available", error);
      setPreviewData(null);
    }
  };

  const handleChange = (content, delta, source, editor) => {
    const value = editor.getText();
    const caret = editor.getSelection()?.index || 0;

    setPostContent(content);
    setCursorPosition(caret);
    detectTrigger(value, caret);

    // ✅ NEW: URL Detection
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const match = value.match(urlRegex);

    if (match && match.length > 0) {
      const url = match[0];

      // Prevent multiple API calls for same URL
      if (url !== detectedUrl) {
        generatePreview(url);
      }
    } else {
      // If link removed, remove preview
      setPreviewData(null);
      setDetectedUrl(null);
    }

    // ===== YOUR EXISTING LOGIC (UNCHANGED) =====

    const updatedDynamicValues = postDynamicValues?.filter(({ type, display }) => {
      const prefix =
        type === "UserMention" || type === "CompanyMention" ? "@" : "#";
      const fullMention = `${prefix}${display}`;
      return value.includes(fullMention);
    }) || [];

    const reassignedDynamicValues = updatedDynamicValues.map((item, index) => ({
      ...item,
      dVno: index + 1
    }));

    setPostDynamicValues(reassignedDynamicValues);

    const quillInstance = editorRef.current?.getEditor?.();
    const htmlContent = quillInstance?.root?.innerHTML || "";

    const updatedPostInputValue =
      updatePostInputValueWithDynamicValues(
        htmlContent,
        reassignedDynamicValues
      );

    setPostInputValue(updatedPostInputValue);
  };


  // const handleChange = (content, delta, source, editor) => {
  //   const value = editor.getText(); // plain text, better than content HTML
  //   const caret = editor.getSelection()?.index || 0;

  //   setPostContent(content); // still keep full HTML
  //   setCursorPosition(caret);
  //   detectTrigger(value, caret);

  //   // Filter out dynamic values no longer in content
  //   const updatedDynamicValues = postDynamicValues?.filter(({ type, display }) => {
  //     const prefix = (type === "UserMention" || type === "CompanyMention") ? "@" : "#";
  //     const fullMention = `${prefix}${display}`;
  //     return value.includes(fullMention);
  //   });

  //   // Reassign dVno after filtering to keep {1}, {2}, ... in correct order
  //   const reassignedDynamicValues = updatedDynamicValues.map((item, index) => ({
  //     ...item,
  //     dVno: index + 1
  //   }));

  //   setPostDynamicValues(reassignedDynamicValues);

  //   // Recompute postInputValue
  //   const quillInstance = editorRef.current?.getEditor?.();
  //   const htmlContent = quillInstance?.root?.innerHTML || "";

  //   const updatedPostInputValue = updatePostInputValueWithDynamicValues(htmlContent, reassignedDynamicValues);

  //   setPostInputValue(updatedPostInputValue);
  // };

  const updatePostInputValueWithDynamicValues = (rawContent, dynamicValues) => {
    let modifiedText = rawContent;

    dynamicValues.forEach(({ type, dVno, display, displayName }) => {
      const prefix = (type === "UserMention" || type === "CompanyMention") ? "@" : "#";
      const fullMention = `${prefix}${display || displayName}`;
      const regex = new RegExp(escapeRegex(fullMention) + "(?!\\S)", "g");
      modifiedText = modifiedText.replace(regex, `{${dVno}}`);
    });

    return modifiedText.trim();
  };

  // Detect @ or #
  const detectTrigger = (value, caret) => {
    const textBeforeCursor = value?.slice(0, caret);
    const match = textBeforeCursor.match(/([@#])(\w*)$/);
    if (match) {
      const trigger = match[1];
      const q = match[2];
      setMentionType(trigger === "@" ? "UserMention" : "Hashtag");
      setQuery(q);
      fetchSuggestions(q, trigger);
      setSearchText(q)
    } else {
      setShowSuggestions(false);
      setSearchText('')
    }
  };

  const fetchSuggestions = async (searchText, triggerChar) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
    };

    try {
      if (triggerChar === "@") {
        const res = await axios.post(`General/MentionTagDDL?Search=${searchText}`, data);
        const results = res.data.responseData || [];
        setSuggestions(results);
        setShowSuggestions(results.length > 0);
      } else if (triggerChar === "#") {
        const res = await axios.post(`General/HashtagDDL?SearchHashtag=${searchText}`, data);
        const results = res.data.responseData || [];
        setSuggestions(results);
        setShowSuggestions(results.length > 0);
      }
    } catch (err) {
      console.error(err);
      if (triggerChar === "#" && searchText) {
        setShowSuggestions(true);
      } else {
        setShowSuggestions(false);
      }
    }
  };

  const insertMention = (suggestion, userUid, entityType) => {
    const quill = editorRef.current?.getEditor?.();
    if (!quill) return;

    const cursorPosition = quill.getSelection()?.index || 0;
    const textBeforeCursor = quill.getText(0, cursorPosition);
    const match = textBeforeCursor.match(/[@#]\w*$/);
    if (!match) return;

    const startIndex = cursorPosition - match[0].length;
    const mentionPrefix = (mentionType === "UserMention" || entityType === "CompanyMention") ? "@" : "#";
    const displayName = suggestion;
    const mentionText = `${mentionPrefix}${displayName} `;

    // Replace partial mention with full one
    quill.deleteText(startIndex, match[0].length);
    quill.insertText(startIndex, mentionText, 'user');
    quill.setSelection(startIndex + mentionText.length);

    // Update dynamic values
    const safePostDynamicValues = Array.isArray(postDynamicValues) ? postDynamicValues : [];
    const dVno = safePostDynamicValues.length + 1;
    let newDynamicValue = null;

    if (mentionType === "UserMention" || entityType === "CompanyMention") {
      newDynamicValue = {
        type: entityType || mentionType,
        dVno,
        entity: userUid, // userUid or companyUid
        display: displayName,
      };
    } else if (mentionType === "Hashtag") {
      newDynamicValue = {
        type: "Hashtag",
        dVno,
        entity: displayName, // naya ya existing hashtag text
        display: displayName,
      };
    }

    const updatedPostDynamicValues = [...safePostDynamicValues, newDynamicValue]
    // {
    //   type: entityType || mentionType,
    //   dVno,
    //   entity: (mentionType === "UserMention" || mentionType === "CompanyMention") ? userUid : suggestion,
    //   display: displayName,
    // },
    //];
    setPostDynamicValues(updatedPostDynamicValues);

    // Replace mentions in HTML with {dVno}
    const editorHtml = quill.root.innerHTML;
    const updatedInputValue = updatePostInputValueWithDynamicValues(editorHtml, updatedPostDynamicValues);
    setPostInputValue(updatedInputValue);
    setShowSuggestions(false);
    setSearchText('')
  };

  // Helper: Escape regex special characters
  const escapeRegex = (str) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };
  // console.log("postContent", postContent, "///", postInputValue)
  // console.log("postDynamicValues", postDynamicValues)

  useEffect(() => {
    if (showArticleModal) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.body.classList.add("modal-open");
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "";
      document.body.classList.remove("modal-open");
    }
  }, [showArticleModal]);

  //DS
  const handleKeyDown1 = (e) => {
    if (showSuggestions) {
      const totalItems = mentionType === "Hashtag" ? suggestions.length + 1 : suggestions.length;
      if (mentionType === "Hashtag" && SearchText) {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          insertMention(SearchText, null, "Hashtag");
          setShowSuggestions(false);
          setSelectedIndex(0);
          return;
        }
      }
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setSelectedIndex((prev) => (prev + 1) % totalItems);
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setSelectedIndex((prev) => (prev - 1 + totalItems) % totalItems);
      } else if (e.key === "Enter") {
        e.preventDefault();

        if (mentionType === "Hashtag" && selectedIndex === 0) {
          insertMention(SearchText, null);
        } else {
          const itemIndex = mentionType === "Hashtag" ? selectedIndex - 1 : selectedIndex;
          const selectedItem = suggestions[itemIndex];
          if (selectedItem) {
            insertMention(
              mentionType === "UserMention" ? selectedItem?.entityName : selectedItem?.hashTag,
              mentionType === "UserMention" ? selectedItem?.userUid : null,
              selectedItem?.entityType
            );
          }
        }

        setShowSuggestions(false);
        setSelectedIndex(0);
      } else if (e.key === "Escape") {
        setShowSuggestions(false);
      }
    }
  };

  useEffect(() => {
    if (itemRefs.current[selectedIndex]) {
      itemRefs.current[selectedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selectedIndex]);

  useEffect(() => {
    if (itemRefs.current[selectedIndex]) {
      itemRefs.current[selectedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selectedIndex]);

  useEffect(() => {
    itemRefs.current = [];
    setSelectedIndex(0);
  }, [suggestions]);

  useEffect(() => {
    if (!showSuggestions) {
      setSelectedIndex(0);
    }
  }, [showSuggestions]);

  return (
    <>
      {show && (
        <div
          className="modal fade show postAdd mt-1"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered" role="document">
            <div className="modal-content d-flex justify-content-around">
              <div className=" modalBorder d-flex justify-content-between align-items-md-center p-2"
              // style={{
              //       direction: language === 'ar' ? 'rtl' : 'ltr',
              //       textAlign: language === 'ar' ? 'right' : 'left',
              //     }}
              >

                <div className="AddedNewPostdiv">
                  <h6 >{t("Newsfeed.Post Something")}</h6>
                  <Select
                    className="privacySelect"
                    classNamePrefix="privacySelect"
                    defaultValue={Privacy.find(
                      (option) => option.value === privacyType
                    )}
                    onChange={(selectedOption) => {
                      setPrivacyType(selectedOption.value);
                    }}
                    options={Privacy}
                    placeholder={t("Newsfeed.Select Privacy")}
                    styles={customStyles}
                    formatOptionLabel={({ label, icon }) => (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        {icon}
                        <span style={{ marginLeft: 8 }}>{label}</span>
                      </div>
                    )}
                  />
                </div>
                <CloseSharpIcon
                  className="pointer"
                  onClick={() => {
                    if (postContent === "" && images.length <= 0) {
                      closeModal();
                      setPostDynamicValues([]);
                      setPostInputValue("");
                      setImages([]);
                      setVideo([]);
                    } else {
                      openDraftModal();
                    }
                  }}
                />
              </div>
              <div className="m-3"
              // style={{
              //   direction: language === 'ar' ? 'rtl' : 'ltr',
              //   textAlign: language === 'ar' ? 'right' : 'left',
              // }} 
              >
                <div className="post-editor-container"
                >
                  <ReactQuill
                    ref={editorRef}
                    value={postContent}
                    onChange={(content, delta, source, editor) => {
                      handleChange(content, delta, source, editor);
                    }}
                    placeholder={t("Newsfeed.What do you want to talk about?")}
                    modules={{ toolbar: false }}
                    onKeyDown={handleKeyDown1}
                  />
                  {previewData && (
                    <div className="card mt-3 link-preview d-flex flex-row">

                      <div>
                        {previewData.image && (
                          <img
                            src={previewData.image}
                            alt="preview"
                            className="card-img-to p-1"
                            width={70}
                          />
                        )}
                      </div>
                      <div className="p-1">
                        <h6 className="f-14">{previewData.title}</h6>
                        <p className="f-12">{previewData.description}</p>
                        <a
                          href={previewData.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="f-12 btn-sm btn-primary"
                        >
                          Visit Site
                        </a>
                      </div>
                    </div>
                  )}


                  {showSuggestions && (
                    <ul
                      className="suggestion-box"
                      ref={suggestionListRef}
                    >
                      {mentionType === "Hashtag" ? <li
                        onMouseDown={(e) => {
                          e.preventDefault(); // Prevent editor blur
                          insertMention(
                            SearchText,
                            null
                          );
                        }}
                        className="suggestion-item"
                      >
                        <span>{SearchText ? `#${SearchText}` : ''}</span>
                      </li> : null}
                      {suggestions?.map((item, index) => {
                        const realIndex = mentionType === "Hashtag" ? index + 1 : index;
                        const isActive = selectedIndex === realIndex;
                        return (
                          <li
                            key={index}
                            ref={(el) => (itemRefs.current[realIndex] = el)}
                            onMouseDown={(e) => {
                              e.preventDefault(); // Prevent editor blur
                              insertMention(
                                mentionType === "UserMention" ? item?.entityName : item?.hashTag,
                                mentionType === "UserMention" ? item?.userUid : null,
                                item.entityType,
                              );
                              setShowSuggestions(false);
                            }}
                            className={`suggestion-item ${isActive ? "active" : ""}`}
                          >
                            {mentionType === "UserMention" ? (
                              <>
                                <img
                                  src={item?.avatar}
                                  alt={item?.entityName}
                                  className="avatar"
                                />
                                <span>{item?.entityName}</span>
                              </>
                            ) : (
                              <span>#{item?.hashTag}</span>
                            )}
                          </li>
                        )
                      })}
                    </ul>
                  )}
                </div>

              </div>

              <div className="modal-border d-flex justify-content-center align-items-center">
                <input
                  id="fileInput"
                  type="file"
                  onChange={imageSelect}
                  style={{ display: "none" }}
                  ref={inputFileRef}
                  multiple
                />

                {images.length > 0 && (
                  <div className="post-selected d-flex justify-content-center flex-wrap">
                    {images.map((image, index) => (
                      <div key={index} className="position-relative m-2">
                        <img
                          src={image.url}
                          alt={`Selected Image ${index}`}
                          style={{
                            maxWidth: "200px",
                            maxHeight: "300px",
                            objectFit: "cover",
                          }}
                        />
                        <button
                          onClick={() => removeImage(index)}
                          className="btn btn-danger position-absolute top-0 end-0"
                          style={{
                            transform: "translate(50%, -50%)",
                            borderRadius: "50%",
                            width: "24px",
                            height: "24px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "0",
                          }}
                        >
                          &times;
                        </button>
                      </div>
                    ))}
                  </div>
                )}
                {video.length > 0 && (
                  <div className="post-selected d-flex justify-content-center flex-wrap">
                    {video.map((video, index) => (
                      <div key={index} className="position-relative m-2">
                        <video maxWidth="200px" width="200" height="100" controls>
                          <source src={video.url} type="video/mp4" alt={`Selected video ${index}`} />
                        </video>
                        <button
                          onClick={() => removeVideo(index)}
                          className="btn btn-danger position-absolute top-0 end-0"
                          style={{
                            transform: "translate(50%, -50%)",
                            borderRadius: "50%",
                            width: "24px",
                            height: "24px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "0",
                          }}
                        >
                          &times;
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="d-flex align-items-center justify-content-between"
                style={{
                  direction: language === 'ar' ? 'rtl' : 'ltr',
                  textAlign: language === 'ar' ? 'right' : 'left',
                }}>
                <div className="m-3 d-flex align-items-center">
                  <form className="form" action="#" method="post" id="form">
                    <input
                      type="file"
                      name="Video"
                      id="Video"
                      accept="video/*"
                      multiple
                      className="d-none"
                      onChange={videoSelect}
                    />
                    <VideoCameraBackIcon
                      className="pointer me-2"
                      onClick={() => document.getElementById("Video").click()}
                    />
                  </form>
                  <form className="form" action="#" method="post" id="form">
                    <input
                      type="file"
                      name="Image"
                      id="image"
                      accept="image/*"
                      multiple
                      className="d-none"
                      onChange={imageSelect}
                    />
                    <ImageSharpIcon
                      className="pointer me-2"
                      onClick={() => document.getElementById("image").click()}
                    />
                  </form>
                  <WorkOutlineSharpIcon
                    className="pointer me-2"
                    onClick={(e) => {
                      if (guestModeData === "true") {
                        setShowJobDraftModal(false);
                      } else if (ownCompanyList === "0") {
                        openWarningModal(); // Open warning modal if the list is empty
                      } else {
                        openJobDraftModal(); // Open job draft modal otherwise
                      }
                    }}
                  />
                  <FaRegPenToSquare
                    className="pointer me-2"
                    onClick={(e) => {
                      if (guestModeData === "true") {
                        return;
                      }

                      closeModal();
                      setTimeout(() => {
                        openArticleModal();
                      }, 100);
                    }}
                  />

                </div>
                <div className="m-3 d-flex">
                  <button
                    className="mainBtn ms-auto"
                    disabled={isloading}
                    onClick={() => {
                      if (isVideoSelected) {
                        handleVideoPostApiCall()

                        //  setTimeout(() => {
                        //   setImages([]);
                        //   setVideo([]);
                        // }, 3000);

                      } else {
                        handleSubmit()
                      }
                    }}
                  >
                    {isloading === true ? t("Newsfeed.Posting") : t("Newsfeed.Post")}
                  </button>
                </div>
              </div>
              <div
                className="card-body d-flex flex-wrap justify-content-start"
                id="container"
              >
                {/* {renderImages()} */}
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="featured-card mb-3 feature-responsive">
        <div className="feature-header p-2 d-flex justify-content-between" style={{
          direction: language === 'ar' ? 'rtl' : 'ltr',
          textAlign: language === 'ar' ? 'right' : 'left',
        }}>
          <h4 className="f-14 fw-bold">{t("Newsfeed.Post Something")}</h4>
        </div>
        <div className="d-flex align-items-center p-3 justify-content-between"
          style={{
            direction: language === 'ar' ? 'rtl' : 'ltr',
            textAlign: language === 'ar' ? 'right' : 'left',
          }}>
          <div className="d-flex align-items-center">

            <div className="ImgAvatar">
              {guestModeData ? (
                <img
                  src={people.DefaultProfile}
                  alt=""
                  height={36}
                  style={{ cursor: "pointer", borderRadius: "50%" }}
                />
              ) : (
                <img
                  src={profilPic}
                  alt=""
                  height={36}
                  style={{ cursor: "pointer", borderRadius: "50%" }}
                />
              )}
            </div>
            <p className="f-16 pointer AddPost ms-2"
              style={{ marginRight: language === 'ar' ? '10px' : 'auto' }}
              onClick={openModal}>
              {/* What's on your mind? */}
              {t("Newsfeed.What's on your mind?")}
            </p>
          </div>
          <div className="ms-aut d-flex">
            <form className="form" action="#" method="post" id="form">
              <input
                type="file"
                name="Video"
                id="Video"
                multiple
                className="d-none"
                onChange={videoSelect}
              />
              <Tooltip title={t("Newsfeed.Post with Video")} arrow>
                <VideoCameraBackIcon
                  style={{ fontSize: "25px" }}
                  className="pointer me-2"
                  onClick={handleShow}
                  title={'video'}
                />
              </Tooltip>
            </form>

            <form className="form" action="#" method="post" id="form">
              <input
                type="file"
                name="Image"
                id="image"
                multiple
                className="d-none"
                onChange={imageSelect}
              />
              <Tooltip title={t("Newsfeed.Post with Image")} arrow>
                <ImageSharpIcon className="me-2 pointer" onClick={handleShow} />
              </Tooltip>
            </form>

            <Tooltip title={t("Newsfeed.Post Job")} arrow>
              <WorkOutlineSharpIcon
                className="pointer me-2"
                onClick={(e) => {
                  if (guestModeData === "true") {
                    setShowJobDraftModal(false);
                  } else if (ownCompanyList === "0") {
                    openWarningModal(); // Open warning modal if the list is empty
                  } else {
                    openJobDraftModal(); // Open job draft modal otherwise
                  }
                }}
              />
            </Tooltip>

            {PostOriginType === "Company" ? "" : (
              <Tooltip title={t("Newsfeed.Post Article")} arrow>
                <span style={{ display: 'inline-block' }}>
                  <FaRegPenToSquare
                    style={{ fontSize: "21px" }}
                    className={`pointer ${language === 'ar' ? 'me-2' : 'me-0'}`}
                    onClick={(e) => {
                      if (guestModeData === "true") {
                        return;
                      }
                      closeModal();
                      setTimeout(() => {
                        openArticleModal();
                      }, 100);
                    }}
                  />
                </span>
              </Tooltip>
            )}

          </div>
        </div>
      </div>

      {showModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered" role="document">
            <div className="modal-content d-flex justify-content-around">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("Newsfeed.Post Something")}</h6>
                <Select
                  defaultValue={Privacy.find(
                    (option) => option.value === privacyType
                  )}
                  onChange={(selectedOption) => {
                    setPrivacyType(selectedOption.value);
                  }}
                  // defaultValue={privacyType}
                  // onChange={(e) => {
                  //   setPrivacyType(e.label);
                  // }}
                  options={Privacy}
                  placeholder={t("Newsfeed.Select Privacy")}
                  styles={customStyles}
                />
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    if (postContent === "" && images.length <= 0) {
                      closeModal();
                      setPostDynamicValues([]);
                      setPostInputValue("");
                      setImages([]);
                      setVideo([]);
                    } else {
                      openDraftModal();
                      setVideo([]);
                    }
                  }}
                />
              </div>
              <div className="d-flex align-items-center m-3 modalBorder ">
                <div className="ImgAvatar">
                  <img
                    src={profilPic}
                    alt=""
                    height={36}
                    style={{ cursor: "pointer", borderRadius: "50%" }}
                  />
                </div>

                <p className="f-16  AddPost ms-2">{t("Newsfeed.What's on your mind?")} </p>
              </div>
              <div className="m-3">
                {/* <textarea
                  autoFocus={true}
                  id="about"
                  placeholder="What do you want to talk about?"
                  name="about"
                  value={postContent}
                  onChange={(e) => setPostContent(e.target.value)}
                  invalid={display && postContent === ""}
                  rows="4"
                  cols="65"
                  style={{ width: "100%" }}
                ></textarea> */}
                <ReactQuill
                  value={postContent}
                  onChange={setPostContent}
                  placeholder={t("Newsfeed.What do you want to talk about?")}
                  // modules={{
                  //   toolbar: [
                  //     [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
                  //     [{ size: [] }],
                  //     ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                  //     [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
                  //     ['link'],
                  //     ['clean']
                  //   ]
                  // }}
                  modules={{
                    toolbar: false, // Hide the toolbar
                  }}
                  formats={[
                    "header",
                    "font",
                    "size",
                    "bold",
                    "italic",
                    "underline",
                    "strike",
                    "blockquote",
                    "list",
                    "bullet",
                    "indent",
                    "link",
                  ]}
                />
              </div>
              <div className="m-3 d-flex align-items-center">
                <form className="form" action="#" method="post" id="form">
                  <input
                    type="file"
                    name="Image"
                    id="image"
                    multiple
                    className="d-none"
                    onChange={imageSelect}
                  />
                  <ImageSharpIcon
                    className="material-symbols-sharp me-2 mt-2 pointer"
                    // onClick={() => document.getElementById("image").click()}
                    onClick={handleShow}
                  />
                </form>
                {/* <WorkOutlineSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={(e) => {
                    guestModeData === "true"
                      ? setShowJobDraftModal(false)
                      : //   e.preventDefault();
                      openJobDraftModal();
                  }}
                /> */}
                <WorkOutlineSharpIcon
                  className="pointer me-2"
                  onClick={(e) => {
                    if (guestModeData === "true") {
                      setShowJobDraftModal(false);
                    } else if (ownCompanyList === "0") {
                      openWarningModal(); // Open warning modal if the list is empty
                    } else {
                      openJobDraftModal(); // Open job draft modal otherwise
                    }
                  }}
                />

                {/* <FaRegPenToSquare
                  className="pointer me-2"
                  onClick={(e) => {
                    if (guestModeData === "true") {
                      // setShowJobDraftModal(false);
                    }  else {
                      openArticleModal();
                    }
                  }}
                /> */}

                <button
                  className="mainBtn ms-auto"
                  disabled={isloading}
                  onClick={() => {
                    if (isVideoSelected) {
                      handleVideoPostApiCall()
                      //  setTimeout(() => {
                      //   handleClose()
                      //   }, 3000);

                    } else {
                      handleSubmit()
                    }
                  }}
                >
                  {isloading === true ? t("Newsfeed.Posting") : t("Newsfeed.Post")}
                </button>
              </div>

              <div
                className="card-body d-flex flex-wrap justify-content-start"
                id="container"
              >
                {renderImages()}
              </div>
              <div
                className="card-body d-flex flex-wrap justify-content-start"
                id="container"
              >
                {renderVideo()}
              </div>
            </div>
          </div>
        </div>
      )}

      {showDraftModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6 className="modalHeader">{t("Newsfeed.Save this post as a draft")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={closeDraftModal}
                />
              </div>
              <div className="d-flex align-items-center modalBorder ">
                <p className="f-14 ms-2 p-2">
                  {t("Newsfeed.The post you started will be here when you return")}
                </p>
              </div>
              <div className="m-3 d-flex align-items-center">
                <button
                  className="wljSecondaryBtn ms-auto me-3"
                  onClick={() => {
                    closeModal();
                    closeDraftModal();
                    setPostContent("");
                  }}
                >
                  {t("Newsfeed.Discard")}
                </button>
                <button
                  className="wljPrimaryBtn"
                  onClick={() => {
                    if (postID === "") {
                      SavePostAsDraft(images);
                      setShowSecondModal(false);
                      closeModal();
                      closeDraftModal();
                      setToastMessage("Post saved as draft successfully!");
                      setShowToast(true);
                      setPostContent("");
                      setImages([]);
                      setVideo([]);
                      setPreviewData(null);
                    } else {
                      UpdatePostAsDraft(images);
                      setShowSecondModal(false);
                      closeModal();
                      closeDraftModal();
                      setToastMessage("Post saved as draft successfully!");
                      setShowToast(true);
                      setPostContent("");
                      setImages([]);
                      setVideo([]);
                      setPreviewData(null);
                    }
                  }}
                >
                  {t("Newsfeed.Save as draft")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showModalData && <ModalForGuest closeModalData={closeModalData} />}
      {showwarningmodal && (
        <CompanyWarning closewarningmodal={closewarningmodal} />
      )}

      {showJobModal && (
        <AddJob
          openModal={openJobModal}
          showModal={showJobModal}
          restrictedViewerToken={restrictedViewerToken}
          closeModal={closeJobModal}
        />
      )}

      {showArticleModal && (
        <AddArticle
          setPostList={setPostList}
          restrictedViewerToken={restrictedViewerToken}
          openModal={openArticleModal}
          showModal={showArticleModal}
          closeModal={closeArticleModal}
        />
      )}

      {showJobDraftModal && (
        <DraftJob
          openModal={openJobDraftModal}
          showModal={showJobDraftModal}
          companyDetails={companyDetails}
          restrictedViewerToken={restrictedViewerToken}
          closeModal={closeJobDraftModal}
        />
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />

      {/* {isVideoProcessing && (
      <LoadingToasterBar
        progress={progress}
        onClose={() => setIsVideoProcessing(false)}
        show={() => setIsVideoProcessing(true)}
      />
    )} */}
    </>
  );
};

export default AddPost;
